import {url} from "./apiurl";
import {authHeader} from '../_helpers/auth-header';
import {handleResponse} from '../_helpers/resposne-handler';

// common service for parent child relationship

const init = {default:"none"}

const getCategories = (data={}) => {
  const reqOptions = {method:"POST", headers:{"Content-Type": "application/json"}, body:JSON.stringify(data)}
      return fetch(`${url}/common/cat-list`,reqOptions).then(handleResponse)
}

const getEmirates = (data={}) => {
  const reqOptions = {method:"POST", headers:{"Content-Type": "application/json"}, body:JSON.stringify(data)}
      return fetch(`${url}/common/emi-list`,reqOptions).then(handleResponse)
}

const getZones = (data=init) => {
  const reqOptions = {method:"POST", headers:{"Content-Type": "application/json"}, body:JSON.stringify(data)}
      return fetch(`${url}/common/zone-list`,reqOptions).then(handleResponse)
}

const getLicenses = (data=init) => {
  const reqOptions = {method:"POST", headers:{"Content-Type": "application/json"}, body:JSON.stringify(data)}
      return fetch(`${url}/common/lic-list`,reqOptions).then(handleResponse)
}

const getSubLicenses = (data=init) => {  
  if(data.zone===null || data.zone.length === 0) delete data.zone;  
  const reqOptions = {method:"POST", headers:{"Content-Type": "application/json"}, body:JSON.stringify(data)}
      return fetch(`${url}/common/sublic-list`,reqOptions).then(handleResponse)
}

const getSubLicenseGroups = (data=init) => {  
  if(data.zone===null || data.zone.length === 0) delete data.zone;  
  const reqOptions = {method:"POST", headers:{"Content-Type": "application/json"}, body:JSON.stringify(data)}
      return fetch(`${url}/common/sublic-group-list`,reqOptions).then(handleResponse)
}

const getActivityGroups = (data=init) => {
  if(data.zone===null || data.zone.length === 0) delete data.zone;
  const reqOptions = {method:"POST", headers:{"Content-Type": "application/json"}, body:JSON.stringify(data)}
      return fetch(`${url}/common/act-group-list`,reqOptions).then(handleResponse)
}

const getActivities = (data=init) => {
  if(data.zone===null || data.zone.length === 0) delete data.zone;
  const reqOptions = {method:"POST", headers:{"Content-Type": "application/json"}, body:JSON.stringify(data)}
      return fetch(`${url}/common/act-list`,reqOptions).then(handleResponse)
}

const getSubActivities = (data=init) => {
  if(data.zone===null || data.zone.length === 0) delete data.zone;
  const reqOptions = {method:"POST", headers:{"Content-Type": "application/json"}, body:JSON.stringify(data)}
      return fetch(`${url}/common/subact-list`,reqOptions).then(handleResponse)
}

export const commonService = {
  getCategories,getEmirates,getZones,getLicenses,getSubLicenses,getSubLicenseGroups,
  getActivityGroups,getActivities,getSubActivities,
}